"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultEditorOptions = exports.getDefaultEditorProps = exports.getDefaults = void 0;
function getDefaults() {
    return {
        lang: 'en'
    };
}
exports.getDefaults = getDefaults;
function getDefaultEditorProps(name) {
    return {};
}
exports.getDefaultEditorProps = getDefaultEditorProps;
function getDefaultEditorOptions(name) {
    return {};
}
exports.getDefaultEditorOptions = getDefaultEditorOptions;
//# sourceMappingURL=registry.js.map